module.exports = __webpack_public_path__ + "static/media/add-noti-start.08781497.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/Assets/img/add-noti-start.png
// module id = 998
// module chunks = 0